import axios from 'axios';
import store from '../store';
import addError from './AddError';

export const ACTIVATE_FEATURE_REQUESTED = 'ACTIVATE_FEATURE_REQUESTED';
export const ACTIVATE_FEATURE_COMPLETED = 'ACTIVATE_FEATURE_COMPLETED';
export const ACTIVATE_FEATURE_FAILED = 'ACTIVATE_FEATURE_FAILED';

const activateFeature = feature => (
  (dispatch) => {
    dispatch({
      type: ACTIVATE_FEATURE_REQUESTED,
    });

    return axios
      .put(`/api/features/${feature}`)
      .then(() => {
        dispatch({
          type: ACTIVATE_FEATURE_COMPLETED,
          data:
            {
              active: 1,
            },
        });
      }).catch((error) => {
        dispatch({
          type: ACTIVATE_FEATURE_FAILED,
        });

        return store.dispatch(addError({
          text: 'Unable to activate feature',
          originalError: error,
        }));
      });
  }
);

export default activateFeature;
